import { Link as LinkButton } from '@huntington/honeycomb';
import { AppBar, Stack, useMediaQuery } from '@mui/material';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import CircadiaLogo from '../../../assets/circadia-2025-white.png';
import { ContactUsModal } from '../../Modals/ContactUsModal/ContactUsModal';

type EnrollmentHeaderProps = {
	showContactLink?: boolean;
};

export default function EnrollmentHeader({ showContactLink = true }: EnrollmentHeaderProps) {
	const isTabletOrMobile = useMediaQuery((theme: any) => theme.breakpoints.down('md'));
	const [contactOpen, setContactOpen] = useState(false);
	const headerHeight = isTabletOrMobile ? '1.5rem' : '2.5rem';

	return (
		<>
			<AppBar position="static" sx={{ backgroundColor: 'brand.secondary' }}>
				<Stack
					direction="row"
					justifyContent="space-between"
					padding={{ xs: '1.5rem', md: '1rem 5rem' }}
				>
					<Link to="/">
						<img
							src={CircadiaLogo}
							alt="Circadia Logo"
							style={{ height: headerHeight }}
							data-testid="circadia-logo"
						/>
					</Link>
					{showContactLink && (
						<LinkButton
							component="button"
							onClick={() => setContactOpen(true)}
							sx={{ color: 'icons.primary', height: headerHeight }}
						>
							Contact Us
						</LinkButton>
					)}
				</Stack>
			</AppBar>

			{/* CONTACT US MODAL */}
			<ContactUsModal open={contactOpen} onClose={() => setContactOpen(false)} />
		</>
	);
}
